export const states = {
    'US': [
        { 'key': 'AL', 'name': 'Alabama' },
        { 'key': 'AK', 'name': 'Alaska' },
        { 'key': 'AS', 'name': 'American Samoa' },
        { 'key': 'AZ', 'name': 'Arizona' },
        { 'key': 'AR', 'name': 'Arkansas' },
        { 'key': 'CA', 'name': 'California' },
        { 'key': 'CO', 'name': 'Colorado' },
        { 'key': 'CT', 'name': 'Connecticut' },
        { 'key': 'DE', 'name': 'Delaware' },
        { 'key': 'DC', 'name': 'District Of Columbia' },
        { 'key': 'FM', 'name': 'Federated States of Micronesia' },
        { 'key': 'FL', 'name': 'Florida' },
        { 'key': 'GA', 'name': 'Georgia' },
        { 'key': 'GU', 'name': 'Guam' },
        { 'key': 'HI', 'name': 'Hawaii' },
        { 'key': 'ID', 'name': 'Idaho' },
        { 'key': 'IL', 'name': 'Illinois' },
        { 'key': 'IN', 'name': 'Indiana' },
        { 'key': 'IA', 'name': 'Iowa' },
        { 'key': 'KS', 'name': 'Kansas' },
        { 'key': 'KY', 'name': 'Kentucky' },
        { 'key': 'LA', 'name': 'Louisiana' },
        { 'key': 'ME', 'name': 'Maine' },
        { 'key': 'MH', 'name': 'Marshall Islands' },
        { 'key': 'MD', 'name': 'Maryland' },
        { 'key': 'MA', 'name': 'Massachusetts' },
        { 'key': 'MI', 'name': 'Michigan' },
        { 'key': 'MN', 'name': 'Minnesota' },
        { 'key': 'MS', 'name': 'Mississippi' },
        { 'key': 'MO', 'name': 'Missouri' },
        { 'key': 'MT', 'name': 'Montana' },
        { 'key': 'NE', 'name': 'Nebraska' },
        { 'key': 'NV', 'name': 'Nevada' },
        { 'key': 'NH', 'name': 'New Hampshire' },
        { 'key': 'NJ', 'name': 'New Jersey' },
        { 'key': 'NM', 'name': 'New Mexico' },
        { 'key': 'NY', 'name': 'New York' },
        { 'key': 'NC', 'name': 'North Carolina' },
        { 'key': 'ND', 'name': 'North Dakota' },
        { 'key': 'MP', 'name': 'Northern Mariana Islands' },
        { 'key': 'OH', 'name': 'Ohio' },
        { 'key': 'OK', 'name': 'Oklahoma' },
        { 'key': 'OR', 'name': 'Oregon' },
        { 'key': 'PW', 'name': 'Palau' },
        { 'key': 'PA', 'name': 'Pennsylvania' },
        { 'key': 'PR', 'name': 'Puerto Rico' },
        { 'key': 'RI', 'name': 'Rhode Island' },
        { 'key': 'SC', 'name': 'South Carolina' },
        { 'key': 'SD', 'name': 'South Dakota' },
        { 'key': 'TN', 'name': 'Tennessee' },
        { 'key': 'TX', 'name': 'Texas' },
        { 'key': 'UT', 'name': 'Utah' },
        { 'key': 'VT', 'name': 'Vermont' },
        { 'key': 'VI', 'name': 'Virgin Islands' },
        { 'key': 'VA', 'name': 'Virginia' },
        { 'key': 'WA', 'name': 'Washington' },
        { 'key': 'WV', 'name': 'West Virginia' },
        { 'key': 'WI', 'name': 'Wisconsin' },
        { 'key': 'WY', 'name': 'Wyoming' },
        { 'key': 'AA', 'name': 'Armed Forces (AA)' },
        { 'key': 'AE', 'name': 'Armed Forces (AE)' },
        { 'key': 'AP', 'name': 'Armed Forces (AP)' }
    ],
    'CA': [
        { 'key': 'AB', 'name': 'Alberta' },
        { 'key': 'BC', 'name': 'British Columbia' },
        { 'key': 'MB', 'name': 'Manitoba' },
        { 'key': 'NB', 'name': 'New Brunswick' },
        { 'key': 'NL', 'name': 'Newfoundland and Labrador' },
        { 'key': 'NT', 'name': 'Northwest Territories' },
        { 'key': 'NS', 'name': 'Nova Scotia' },
        { 'key': 'NU', 'name': 'Nunavut' },
        { 'key': 'ON', 'name': 'Ontario' },
        { 'key': 'PE', 'name': 'Prince Edward Island' },
        { 'key': 'QC', 'name': 'Quebec' },
        { 'key': 'SK', 'name': 'Saskatchewan' },
        { 'key': 'YT', 'name': 'Yukon Territory' }
    ],
    'AU': [
        { 'key': 'ACT', 'name': 'Australian Capital Territory' },
        { 'key': 'NSW', 'name': 'New South Wales' },
        { 'key': 'NT', 'name': 'Northern Territory' },
        { 'key': 'QLD', 'name': 'Queensland' },
        { 'key': 'SA', 'name': 'South Australia' },
        { 'key': 'TAS', 'name': 'Tasmania' },
        { 'key': 'VIC', 'name': 'Victoria' },
        { 'key': 'WA', 'name': 'Western Australia' }
    ]
};
